import React, { useContext } from 'react';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import MultiSelector from '../../UI/MultiSelector/MultiSelector';
import FiltersContext from '../../../context/FiltersContext';

// Interfaces 
import { PreconfigDataDispatch } from '../../../hooks/preconfig-hooks';

interface Props {
    selectedPreconfigIDs: number[]
    dispatchPreconfig: React.Dispatch<PreconfigDataDispatch>
}

const MultiSelectProfiles: React.FC<Props> = ({
    selectedPreconfigIDs,
    dispatchPreconfig,
}) => {
    const { t } = useTranslation();
    const { profiles } = useContext(FiltersContext);

    const handleChangeProfiles = (id: number | string) => {
        if (id === -1) {
            dispatchPreconfig({
                type: 'SET_PROFILES',
                payload: selectedPreconfigIDs.length === profiles.length ? [] : profiles.map(profile => profile.id)
            });
            return;
        }

        dispatchPreconfig({ type: 'ADD_PROFILE', payload: Number(id) });
    };

    const profilesOptions = profiles.map(profile => ({
        id: profile.id,
        name: profile.name,
        checked: selectedPreconfigIDs.some(id => id === profile.id)
    }));

    return (
        <MultiSelector
            label={t('link_environment') as string}
            options={profilesOptions}
            handleChange={handleChangeProfiles}
        />
    );
};

export default MultiSelectProfiles;